<template>
  <el-config-provider :locale="locale">
    <router-view v-if="flag" />
    <longfor-layout v-else >
      <router-view />
    </longfor-layout>
  </el-config-provider>
</template>

<script lang="ts">
import {
  defineComponent, reactive, ref, toRefs, watch
} from 'vue';
  import { ElConfigProvider } from 'element-plus';
  import zhCn from 'element-plus/es/locale/lang/zh-cn';
  import { SessionStorageService, LocalStorageService } from '@/utils/storage';
  import { useResize } from '@/hooks';
  import { setThemeColor, setTextColor } from '@/utils/resetElColor';
  // import store from '@/store/index';
  // import { SET_USER_INFO } from '@/store/actionTypes';
  import longforLayout from '@/layout/longfor-layout.vue';
  import {useRoute,useRouter} from "vue-router";
  export default defineComponent({
    components: {
      [ElConfigProvider.name]: ElConfigProvider,
      longforLayout,
    },
    setup() {
      const route = useRoute();
      const router = useRouter();
      setThemeColor(); // 格式化elementUi用到的主要颜色
      setTextColor(); // 格式化elementUi用到的字体颜色
      useResize();
      const nameList = ['404','401','reportShare']
      const state = reactive({
        locale: zhCn,
      });
      const flag = ref(false)

      // 清除storage中过期的内容
      LocalStorageService.clearExpired();
      SessionStorageService.clearExpired();
      watch(
          route,
          (val:any) => {
            flag.value = nameList.indexOf(val.name) > -1
          },
          {
            immediate: true,
          }
      );

      // // 获取用户信息
      // store.dispatch(`user/${SET_USER_INFO}`).then((userInfo) => {
      //   window.zhuge.identify(userInfo.oa, {
      //     名称: userInfo.userName,
      //     OA: userInfo.oa,
      //     角色: userInfo.roles,
      //   });

      //   window.zhuge.setSuperProperty({
      //     名称: userInfo.userName,
      //     OA: userInfo.oa,
      //     角色: userInfo.roles,
      //   });
      // });

      return {
        ...toRefs(state),
        flag,
      };
    },
  });
</script>
